import { Species } from './species';

export class SurgicalOperation {
    id: number | null = null;
    species: Species | null = null;
    name: string = '';
}